// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qWGRt","label":"styles_label__3PjVW"};